var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("text")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-custom-language-select", {
                            model: {
                              value: _vm.lang,
                              callback: function ($$v) {
                                _vm.lang = $$v
                              },
                              expression: "lang",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    { staticClass: "value-button" },
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(" " + _vm._s(_vm.$ct("titleLabel")) + " "),
                      ]),
                      _c(
                        "w-col",
                        { attrs: { center: "" } },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(`tooltip.style-edit`),
                                  expression: "$ct(`tooltip.style-edit`)",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editStyle("TitleStyle")
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { size: "lg", icon: "font" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    { staticClass: "value-button" },
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(" " + _vm._s(_vm.$ct("textLabel")) + " "),
                      ]),
                      _c(
                        "w-col",
                        { attrs: { center: "" } },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(`tooltip.style-edit`),
                                  expression: "$ct(`tooltip.style-edit`)",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editStyle("TextStyle")
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { size: "lg", icon: "font" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    { staticClass: "value-button" },
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(" " + _vm._s(_vm.$ct("signature")) + " "),
                      ]),
                      _c(
                        "w-col",
                        { attrs: { center: "" } },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(`tooltip.style-edit`),
                                  expression: "$ct(`tooltip.style-edit`)",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editStyle("SignatureStyle")
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { size: "lg", icon: "font" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    { staticClass: "value-button" },
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(" " + _vm._s(_vm.$ct("date")) + " "),
                      ]),
                      _c(
                        "w-col",
                        { attrs: { center: "" } },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(`tooltip.style-edit`),
                                  expression: "$ct(`tooltip.style-edit`)",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editStyle("DateStyle")
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { size: "lg", icon: "font" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toEditStyle
        ? _c(
            "w-modal",
            { attrs: { value: _vm.toEditStyle != null } },
            [
              _c("app-style-editor", {
                on: {
                  close: function ($event) {
                    _vm.toEditStyle = null
                  },
                },
                model: {
                  value: _vm.layout[_vm.toEditStyle],
                  callback: function ($$v) {
                    _vm.$set(_vm.layout, _vm.toEditStyle, $$v)
                  },
                  expression: "layout[toEditStyle]",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }